/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { Table, Empty } from 'antd';
import tableColumns from './tableColumns';
import SettingsWorkPlacesContext from '../../../contexts/settings-contexts/SettingsWorkPlacesProvider';
import geAllWorkPlacesApi from '../../../apis/settings-apis/work-places-apis/getAllWokrPlacesApi';
import UserContext from '../../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import { useTranslation } from 'react-i18next';

// const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const PageTable = () => {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();
  const {
    allFetchedPlaces,
    setAllFetchedPlaces,
    isLoading,
    setIsLoading,
    setModalOpened,
    fetchCount,
    setFetchCount,
    setSelectedPlace
  } = useContext(SettingsWorkPlacesContext);

  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id,
      index: index + 1,
      name: obj?.name ? obj.name : '',
      title: obj?.title ? obj.title : ''
    }));
  };
  const customApiRequest = useCustomApiRequest();
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setIsLoading(true);
      customApiRequest(
        geAllWorkPlacesApi(user?.token),
        (res) => {
          setIsLoading(false);
          if (res?.status === 200 && res?.data?.data?.length >= 0) {
            const data = res.data.data;
            setAllFetchedPlaces(data);
          } else {
          }
        },
        (error) => {
          setIsLoading(false);
        }
      );
    }

    return () => {
      isMounted = false;
    };
  }, [fetchCount]);

  // map all data to dataSource
  useEffect(() => {
    let isMounted = true;
    if (allFetchedPlaces?.length >= 0) {
      const mappedData = mapDataSource(allFetchedPlaces);
      if (isMounted) {
        setTableDataSource(mappedData);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [fetchCount, allFetchedPlaces, allFetchedPlaces?.length]);

  return (
    <Table
      locale={{
        emptyText: (
          <Empty description={false}>
            {t('Inventory.Warehouses.noDataAvailable')}
          </Empty>
        )
      }}
      pagination={{ defaultPageSize: 5, hideOnSinglePage: true }}
      className="antd-custom-table"
      dataSource={tableDataSource}
      columns={tableColumns(
        allFetchedPlaces,
        setModalOpened,
        setFetchCount,
        setSelectedPlace,
        setIsLoading,
        t,
        user?.token
      )}
      loading={isLoading}
      // scroll={{ x: 400 }}
      footer={false}
    />
  );
};

export default PageTable;
